import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import {
    selectIsBtnNewNoteGrabEnabled,
    selectScale,
} from '../../../redux/diagram/diagram.selectors';

import './DraggableNote.scss';

// Drag-and-drop ghost for the ControlsLeft note tool — the note twin of
// DraggableTable. The cursor offset (160/40 × scale) matches the drop math in
// Canvas's grab-release branch, so the ghost sits exactly where the note will
// be created. Size/colors mirror buildNewNote (360×190) and drawNote's dark
// body.
export const DraggableNote = () => {
    const isBtnNewNoteGrabEnabled = useSelector(selectIsBtnNewNoteGrabEnabled);
    const scale = useSelector(selectScale);

    const [mouseXY, setMouseXY] = useState({ x: 0, y: 0 });

    useEffect(() => {
        const handleDocumentMouseMove = (event) => {
            const mouseX = event.clientX - 160 * scale;
            const mouseY = event.clientY - 40 * scale;

            setMouseXY({ x: mouseX, y: mouseY });
        };

        document.addEventListener('mousemove', handleDocumentMouseMove);

        return () => {
            document.removeEventListener('mousemove', handleDocumentMouseMove);
        };
    }, [isBtnNewNoteGrabEnabled, scale]);

    return (
        <div>
            {isBtnNewNoteGrabEnabled && (
                <div
                    className="drag-element-note selected"
                    style={{
                        left: `${mouseXY.x}px`,
                        top: `${mouseXY.y}px`,
                        width: `${360 * scale}px`,
                        height: `${190 * scale}px`,
                        borderRadius: `${5 * scale}px`,
                        borderWidth: `${1 * scale}px`,
                    }}
                ></div>
            )}
        </div>
    );
};

export default DraggableNote;
